export const FacebookIcon = () => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="50" height="50" rx="5" fill="currentColor" />
            <path
                d="M36.6231 13H14.3769C14.0117 13 13.6615 13.1451 13.4033 13.4033C13.1451 13.6615 13 14.0117 13 14.3769V36.6231C13 36.9883 13.1451 37.3385 13.4033 37.5967C13.6615 37.8549 14.0117 38 14.3769 38H26.3552V28.3184H23.0796V24.5534H26.3391V21.7672C26.3391 18.54 28.3077 16.7812 31.1799 16.7812C32.1519 16.7767 33.1234 16.827 34.0897 16.9318V20.3042H32.0942C30.5237 20.3042 30.2225 21.0519 30.2225 22.1437V24.5534H33.9606L33.4712 28.3184H30.244V38H36.6177C36.9829 38 37.3331 37.8549 37.5913 37.5967C37.8496 37.3385 37.9946 36.9883 37.9946 36.6231V14.3769C37.9946 14.0127 37.8503 13.6633 37.5932 13.4052C37.3362 13.1471 36.9873 13.0014 36.6231 13Z"
                fill="black"
            />
        </svg>
    );
};
